import { ExchangeReportProfileInboxRule } from '../../microsoft/exchange/profile/exchange-report-profile-inbox-rule';
import { ReportProfileAlertResourceBaseModel } from '../../profile/report-profile-alert-resource-base-model';

export class ExchangeReportProfileAlertInboxRuleModel extends ReportProfileAlertResourceBaseModel {
  inboxRule: ExchangeReportProfileInboxRule;
}
